import { z } from 'zod';
/**
 * Record counts: how many live (not soft-deleted) records the acting organisation holds, per
 * kind, with what hangs off each — `GET /stats/record-counts`. Custom fields are two numbers:
 * the definitions the caller may see, and the value rows of those definitions that hold a value
 * on a live record. Notes are live notes on live records of that kind.
 */
const count = z.number().int().nonnegative();
export const customFieldCountsSchema = z.object({ definitions: count, values: count });
const withNotes = z.object({ count, customFields: customFieldCountsSchema, notes: count });
export const recordCountsSchema = z
    .object({
    candidates: withNotes,
    projects: withNotes,
    deals: withNotes,
    /** `shortlistedCandidates` = live places on live shortlists of live jobs. */
    jobs: withNotes.extend({ shortlists: count, shortlistedCandidates: count }),
    companies: z.object({ count, customFields: customFieldCountsSchema }),
})
    .meta({
    examples: [
        {
            candidates: { count: 1250, customFields: { definitions: 31, values: 18_400 }, notes: 920 },
            projects: { count: 410, customFields: { definitions: 17, values: 2100 }, notes: 640 },
            deals: { count: 530, customFields: { definitions: 35, values: 4200 }, notes: 75 },
            jobs: {
                count: 380,
                customFields: { definitions: 34, values: 3900 },
                notes: 210,
                shortlists: 395,
                shortlistedCandidates: 2600,
            },
            companies: { count: 400, customFields: { definitions: 45, values: 5200 } },
        },
    ],
});
//# sourceMappingURL=record-counts.js.map